import { Resume } from 'packages/types'
import {
  ColorChangeHandler,
  FontChangeHandler,
  LayoutFormatChangeHandler,
  SizeChangeHandler,
  SpacingChangeHandler,
  TemplateChangeHandler,
} from 'builder/modules/resumeEditor'

export interface TemplateCustomizationSheetProps {
  onClose: () => void
  resume: Resume
  updateTemplate: TemplateChangeHandler
  handleColorSelect: ColorChangeHandler
  handleFontChange?: FontChangeHandler
  handleChangeLayoutFormat?: LayoutFormatChangeHandler
  handleSpacingChange?: SpacingChangeHandler
  handleSizeChange?: SizeChangeHandler
}

export enum TabType {
  templates = 'templates',
  text = 'text',
  layout = 'layout',
}

export interface Tab {
  label: React.ReactElement
  id: TabType
  content: React.ReactElement
}
